import { atomWithStorage } from 'jotai/utils';

export const authAtom = atomWithStorage<any>('auth-info', {});
